/**

 * GA4 (dataLayer) + Meta Pixel + Meta CAPI + TikTok Pixel — TotulOnline storefront

 * Checkout purchase / shipping / payment → docs/gtm-checkout-pixel.js (Custom Pixel)

 */

(function () {

  'use strict';

  if (!window.theme) return;



  var CURRENCY = theme.currency || 'RON';

  var META_CAPI_URL = theme.metaCapiEndpoint || '';

  window.dataLayer = window.dataLayer || [];



  function centsToUnits(cents) {

    return Math.round(Number(cents) || 0) / 100;

  }



  function pushDataLayer(event, ecommerce, extras) {

    window.dataLayer.push({ ecommerce: null });

    var payload = { event: event, ecommerce: Object.assign({ currency: CURRENCY }, ecommerce || {}) };

    if (extras && typeof extras === 'object') {

      Object.keys(extras).forEach(function (k) { payload[k] = extras[k]; });

    }

    window.dataLayer.push(payload);

  }



  /** Marka (vendor) + ürün hattı (Shopify product type: Macun, Parfüm vb.) — GTM tetikleyicileri */

  function enrichGaItem(item, src) {

    src = src || {};

    var brand = src.vendor || src.item_brand || item.item_brand || '';

    var line = src.type || src.product_type || src.item_category || item.item_category || '';

    var collection = src.collection || src.item_category2 || item.item_category2 || '';

    if (!line && collection) line = collection;

    item.item_brand = brand;

    item.item_category = line;

    if (collection) item.item_category2 = collection;

    return item;

  }



  function dlItemContext(items) {

    var first = (items && items[0]) || {};

    return {

      item_brand: first.item_brand || '',

      item_category: first.item_category || '',

      item_category2: first.item_category2 || '',

      product_brand: first.item_brand || '',

      product_line: first.item_category || ''

    };

  }



  function getCookie(name) {

    var re = new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)');

    var m = document.cookie.match(re);

    return m ? decodeURIComponent(m[1]) : '';

  }



  function newEventId() {

    return 'totul_' + Date.now() + '_' + Math.random().toString(36).slice(2, 11);

  }



  function metaCapiSend(eventName, eventId, customData) {

    if (!META_CAPI_URL || !eventId) return;

    try {

      fetch(META_CAPI_URL, {

        method: 'POST',

        headers: { 'Content-Type': 'application/json' },

        credentials: 'omit',

        keepalive: true,

        body: JSON.stringify({

          event_name: eventName,

          event_id: eventId,

          event_source_url: location.href,

          user_data: {

            fbp: getCookie('_fbp'),

            fbc: getCookie('_fbc'),

            client_user_agent: navigator.userAgent

          },

          custom_data: customData || {}

        })

      }).catch(function () {});

    } catch (e) { /* sessiz */ }

  }



  function metaTrack(event, params) {

    if (typeof window.fbq !== 'function') return null;

    var eventId = newEventId();

    try {

      window.fbq('track', event, params || {}, { eventID: eventId });

    } catch (e) { return null; }

    metaCapiSend(event, eventId, params);

    return eventId;

  }



  function ttqTrack(event, params) {

    if (typeof window.ttq === 'undefined') return;

    try {

      if (event === 'PageView') {

        window.ttq.page();

      } else {

        window.ttq.track(event, params || {});

      }

    } catch (e) { /* sessiz */ }

  }



  function gaItemFromCartLine(item) {

    if (!item) return null;

    return enrichGaItem({

      item_id: String(item.sku || item.variant_id || item.id || ''),

      item_name: item.product_title || item.title || '',

      item_variant: item.variant_title || '',

      price: centsToUnits(item.final_price != null ? item.final_price : item.price),

      quantity: item.quantity || 1

    }, {

      vendor: item.vendor,

      product_type: item.product_type

    });

  }



  function gaItemsFromCart(cart) {

    return (cart.items || []).map(gaItemFromCartLine).filter(Boolean);

  }



  function cartValue(cart) {

    return centsToUnits(cart.total_price || 0);

  }



  function metaContentsFromGaItems(gaItems) {

    return gaItems.map(function (it) {

      return { id: it.item_id, quantity: it.quantity, item_price: it.price };

    });

  }



  function tiktokContentsFromGaItems(gaItems) {

    return gaItems.map(function (it) {

      return {

        content_id: it.item_id,

        content_name: it.item_name,

        quantity: it.quantity,

        price: it.price

      };

    });

  }



  function pushViewItem(product, variant) {

    if (!product || !variant) return;

    var price = centsToUnits(variant.price);

    var itemId = String(variant.sku || variant.id || product.id);

    var item = enrichGaItem({

      item_id: itemId,

      item_name: product.title || '',

      item_variant: (variant.options || []).join(' / '),

      price: price,

      quantity: 1

    }, {

      vendor: product.vendor,

      type: product.type,

      collection: product.collection

    });

    pushDataLayer('view_item', { value: price, items: [item] }, dlItemContext([item]));

    metaTrack('ViewContent', {

      content_ids: [itemId],

      content_type: 'product',

      content_name: product.title || '',

      value: price,

      currency: CURRENCY

    });

    ttqTrack('ViewContent', {

      content_id: itemId,

      content_type: 'product',

      content_name: product.title || '',

      value: price,

      currency: CURRENCY

    });

  }



  function pushAddToCart(items) {

    var gaItems = (items || []).map(gaItemFromCartLine).filter(Boolean);

    if (!gaItems.length) return;

    var value = gaItems.reduce(function (sum, it) { return sum + (it.price * it.quantity); }, 0);

    var contentIds = gaItems.map(function (it) { return it.item_id; });

    pushDataLayer('add_to_cart', { value: value, items: gaItems }, dlItemContext(gaItems));

    metaTrack('AddToCart', {

      content_ids: contentIds,

      content_type: 'product',

      value: value,

      currency: CURRENCY,

      contents: metaContentsFromGaItems(gaItems)

    });

    ttqTrack('AddToCart', {

      content_id: contentIds[0],

      content_type: 'product',

      value: value,

      currency: CURRENCY,

      contents: tiktokContentsFromGaItems(gaItems)

    });

  }



  function pushViewCart(cart) {

    if (!cart || !cart.items || !cart.items.length) return;

    var viewItems = gaItemsFromCart(cart);

    pushDataLayer('view_cart', { value: cartValue(cart), items: viewItems }, dlItemContext(viewItems));

  }



  function pushBeginCheckout(cart) {

    if (!cart) return;

    var items = gaItemsFromCart(cart);

    var value = cartValue(cart);

    var contentIds = items.map(function (it) { return it.item_id; });

    var numItems = items.reduce(function (n, it) { return n + it.quantity; }, 0);

    pushDataLayer('begin_checkout', { value: value, items: items }, dlItemContext(items));

    metaTrack('InitiateCheckout', {

      content_ids: contentIds,

      content_type: 'product',

      value: value,

      currency: CURRENCY,

      num_items: numItems

    });

    ttqTrack('InitiateCheckout', {

      content_id: contentIds[0],

      content_type: 'product',

      value: value,

      currency: CURRENCY,

      quantity: numItems

    });

  }



  function persistGaClientId() {
    var mid = (window.theme && theme.ga4MeasurementId) || 'G-2NY5P5K6X5';
    var tries = 0;
    function write(cid, sid) {
      var attrs = {};
      if (cid) attrs._ga_client_id = String(cid);
      if (sid) attrs._ga_session_id = String(sid);
      if (!Object.keys(attrs).length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: attrs }),
      }).catch(function () {});
    }
    function tick() {
      tries += 1;
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('get', mid, 'client_id', function (cid) {
            window.gtag('get', mid, 'session_id', function (sid) {
              write(cid, sid);
            });
          });
        } catch (e) { /* sessiz */ }
        return;
      }
      if (tries < 16) setTimeout(tick, 500);
    }
    setTimeout(tick, 900);
  }

  function onPageLoad() {

    window.dataLayer.push({

      event: 'page_view',

      page_type: document.body.className.match(/template-(\S+)/) ? document.body.className.match(/template-(\S+)/)[1] : '',

      page_path: location.pathname,

      page_title: document.title

    });



    persistGaClientId();

    if (document.body.classList.contains('template-product')) {

      var root = document.querySelector('[data-product-json]');

      var meta = document.querySelector('[data-analytics-product]');

      if (root && meta) {

        try {

          var product = JSON.parse(meta.textContent);

          var data = JSON.parse(root.textContent);

          var variant = (data.variants || [])[0];

          if (variant) pushViewItem(product, variant);

        } catch (e) { /* sessiz */ }

      }

    }



    if (document.body.classList.contains('template-cart')) {

      fetch(theme.routes.cart + '.js', { credentials: 'same-origin' })

        .then(function (r) { return r.json(); })

        .then(pushViewCart)

        .catch(function () {});

    }

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', onPageLoad);

  } else {

    onPageLoad();

  }



  document.addEventListener('cart:added', function (e) {

    var detail = e.detail || {};

    pushAddToCart(detail.items || (detail.item ? [detail.item] : []));

  });



  document.addEventListener('cart:opened', function (e) {

    if (e.detail) pushViewCart(e.detail);

  });



  document.addEventListener('click', function (e) {

    var checkoutBtn = e.target.closest('[name="checkout"], [data-checkout], a[href*="/checkout"]');

    if (!checkoutBtn) return;

    fetch(theme.routes.cart + '.js', { credentials: 'same-origin' })

      .then(function (r) { return r.json(); })

      .then(pushBeginCheckout)

      .catch(function () {});

  }, true);



  document.addEventListener('variant:changed', function (e) {

    var detail = e.detail || {};

    if (detail.product && detail.variant) pushViewItem(detail.product, detail.variant);

  });



  window.TotulAnalytics = {

    pushViewItem: pushViewItem,

    pushAddToCart: pushAddToCart,

    pushViewCart: pushViewCart,

    pushBeginCheckout: pushBeginCheckout,

    pushDataLayer: pushDataLayer,

    metaTrack: metaTrack,

    metaCapiSend: metaCapiSend,

    ttqTrack: ttqTrack,

    newEventId: newEventId

  };

})();

